import { createContext, type PropsWithChildren, useContext, useState } from 'react'

interface ViewingDirectionContextType {
  azimuthalAngle: number
  polarAngle: number
  setAzimuthalAngle: (angle: number) => void
  setPolarAngle: (angle: number) => void
  syncedImageId: string | undefined
  setSyncedImageId: (id: string | undefined) => void
}

const ViewingDirectionContext = createContext<ViewingDirectionContextType | undefined>(undefined)

export function ViewingDirectionProvider({ children }: PropsWithChildren) {
  const [azimuthalAngle, setAzimuthalAngle] = useState(0)
  const [polarAngle, setPolarAngle] = useState(Math.PI / 2)

  // synced image id is the id of the image that the directions are currently associated with
  const [syncedImageId, setSyncedImageId] = useState<string | undefined>(undefined)

  return (
    <ViewingDirectionContext.Provider value={{
      azimuthalAngle,
      setAzimuthalAngle,
      polarAngle,
      setPolarAngle,
      syncedImageId,
      setSyncedImageId,
    }}>
      {children}
    </ViewingDirectionContext.Provider>
  )
}

// eslint-disable-next-line react-refresh/only-export-components
export function useViewingDirection() {
  const context = useContext(ViewingDirectionContext)

  if (context === undefined) {
    throw new Error('useViewingDirection must be used within a ViewingDirectionProvider')
  }

  return context
}
